import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { List, Row, Col, Button, Spin, Card, Avatar, Modal, Affix } from 'antd';
import {
  LoadingOutlined,
  GatewayOutlined,
  UnorderedListOutlined,
  EyeOutlined,
  CloseOutlined
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useQuery } from '@apollo/react-hooks';
import { Link } from 'react-router-dom';
import RegisterForm from '../RegisterForm/RegisterForm';
import { MobileView, BrowserView } from 'react-device-detect';
import { gaEvent } from '../../utils';

import _s from './index.less';
import Filters from './Filters';
import Map from './Map';

const { Meta } = Card;
const antIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

export const Plan = ({ item, getActions = () => null }) => {
  const { meta, isHidden } = item;
  return (
    <Card
      cover={
        <img
          style={{ opacity: isHidden ? 0.6 : 1.0 }}
          alt=""
          src={item.logo || item.image}
          className={_s.imageList}
          aria-hidden="true"
        />
      }
      actions={getActions(item)}
    >
      <Meta
        avatar={
          <Avatar src="https://s3-us-west-2.amazonaws.com/adu.homewip/images/eb48c0f5-6673-4f56-9cbd-4b6d3e55e138" />
        }
        title={(item.title || 'House').toUpperCase()}
        description={
          <div>
            {meta.width ? <span className={_s.metaPlanList}>Width: {meta.width}&apos;</span> : null}
            {meta.length ? (
              <span className={_s.metaPlanList}>Length: {meta.length}&apos;</span>
            ) : null}
          </div>
        }
      />
    </Card>
  );
};

export const Plans = ({ items, viewMode, getActions }) => {
  return (
    <List
      grid={{ gutter: 16, column: 1 }}
      dataSource={items}
      renderItem={item => {
        return (
          <List.Item>
            <Plan item={item} viewMode={viewMode} getActions={getActions} />
          </List.Item>
        );
      }}
    />
  );
};

const btnStyle = {
  textAlign: 'center',
  width: '300px',
  height: '60px',
  top: '30px',
  border: '1px solid #EE8865',
  boxSizing: 'border-box',
  color: '#000000'
};

const textStyleButton = {
  fontStyle: 'normal',
  fontWeight: 300,
  fontSize: '20px'
};

const ListContainer = props => {
  const refController = useRef(null);
  const { prefix, queries } = props;
  const [filters, setFilters] = useState({});
  const [planView, setPlanView] = useState({});
  const [loadMap, setLoadMap] = useState(false);
  const [unlocked, setUnlocked] = useState(true);
  const [open, setOpen] = useState(false);

  const { data, refetch, loading } = useQuery(queries, {
    variables: { ...filters }
  });
  const items = (data && data[Object.keys(data)[0]]) || [];

  useEffect(() => {
    gaEvent('mapView', 'loaded:finish_loading_map_view');
  }, []);

  useEffect(() => {
    refetch();
  }, [data, filters]);

  const onPlace = (e, plan) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(false);
    setUnlocked(false);
    setPlanView(plan);
  };

  const onView = async e => {
    e.preventDefault();
    setOpen(false);
    setUnlocked(false);
  };

  const getActions = item => {
    const actions = [
      <div
        className={_s.viewButton}
        key={`link-${item.id}`}
        onClick={e => onPlace(e, item)}
        aria-hidden="true"
      >
        <GatewayOutlined />
        <span>Select</span>
      </div>
    ];
    return actions;
  };

  return (
    <>
      <BrowserView>
        <div
          className={_s.mapListViewContainer}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <Row justify="space-around" align="stretch" style={{ height: '100%', flex: 1 }}>
            <Col span={24} lg={14} style={{ height: '100%' }}>
              <Map
                refController={refController}
                plan={planView}
                onChange={() => setUnlocked(false)}
                onLoad={setLoadMap}
              />
              {loadMap && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10
                  }}
                >
                  <Spin size="large" indicator={antIcon} />
                </div>
              )}
            </Col>
            <Col
              span={24}
              lg={10}
              style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: 'white'
              }}
            >
              <Row justify="space-around" align="stretch">
                <Col span={22}>
                  <Filters
                    {...{
                      prefix,
                      filters,
                      setFilters,
                      refetch,
                      role: 'USER',
                      optional: false,
                      setUnlocked,
                      unlocked
                    }}
                  />
                </Col>
              </Row>
              <Row justify="space-around" align="stretch" style={{ flex: 1, overflowY: 'auto' }}>
                <Col span={22}>
                  {loading ? (
                    <Row justify="center" style={{ height: '100%' }}>
                      <Col>
                        <Spin size="large" indicator={antIcon} />
                      </Col>
                    </Row>
                  ) : (
                    <Plans items={items} viewMode={0} getActions={getActions} />
                  )}
                </Col>
                <Col span={22} style={{ marginBottom: '30px' }}>
                  <Button
                    disabled={loadMap}
                    loading={loadMap}
                    style={{
                      ...btnStyle,
                      ...textStyleButton,
                      width: '100%',
                      top: '10px'
                    }}
                    onClick={onView}
                  >
                    <UnorderedListOutlined />
                    Load more...
                  </Button>
                </Col>
              </Row>
              {planView.id && (
                <Row justify="center" style={{ height: '80px' }}>
                  <Col span={22}>
                    <Button
                      disabled={loadMap}
                      loading={loadMap}
                      style={{
                        ...btnStyle,
                        ...textStyleButton,
                        width: '100%',
                        top: '10px',
                        background: '#EE8865'
                      }}
                      onClick={onView}
                    >
                      View
                    </Button>
                  </Col>
                </Row>
              )}
            </Col>
          </Row>
        </div>
      </BrowserView>
      <MobileView>
        <div
          className={_s.mapListViewContainer}
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <Row justify="space-around" align="stretch" style={{ height: '100%', flex: 1 }}>
            <Col span={24} style={{ height: '100%' }}>
              <Map
                refController={refController}
                plan={planView}
                onChange={() => setUnlocked(false)}
                onLoad={setLoadMap}
              />
              {loadMap && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10
                  }}
                >
                  <Spin size="large" indicator={antIcon} />
                </div>
              )}
            </Col>
            <div
              style={{
                position: 'absolute',
                bottom: '10px',
                height: '80px',
                width: '100vw'
              }}
            >
              <Col
                span={24}
                style={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <Row gutter={[16, 16]} justify="center">
                  <Col span={8}>
                    <Button
                      disabled={loadMap}
                      loading={loadMap}
                      style={{
                        ...btnStyle,
                        ...textStyleButton,
                        width: '100%',
                        top: '10px'
                      }}
                      onClick={() => setOpen(true)}
                    >
                      <UnorderedListOutlined />
                      Plans
                    </Button>
                  </Col>
                  {planView.id && (
                    <Col span={14}>
                      <Button
                        disabled={loadMap}
                        loading={loadMap}
                        style={{
                          ...btnStyle,
                          ...textStyleButton,
                          width: '100%',
                          top: '10px',
                          background: '#EE8865'
                        }}
                        onClick={onView}
                      >
                        <EyeOutlined />
                        Estimate
                      </Button>
                    </Col>
                  )}
                </Row>
                <Modal
                  title="Plans"
                  centered
                  visible={open}
                  cancelText="Close"
                  onCancel={() => setOpen(false)}
                  footer={
                    <Row gutter={[16, 16]} justify="center">
                      {planView.id && (
                        <Col span={22}>
                          <Affix offsetBottom={50}>
                            <Button
                              disabled={loadMap}
                              loading={loadMap}
                              style={{
                                ...btnStyle,
                                ...textStyleButton,
                                width: '100%',
                                top: '10px',
                                background: '#EE8865'
                              }}
                              onClick={onView}
                            >
                              <EyeOutlined />
                              Estimate
                            </Button>
                          </Affix>
                        </Col>
                      )}
                      <Col span={22}>
                        <Button
                          disabled={loadMap}
                          loading={loadMap}
                          style={{
                            ...btnStyle,
                            ...textStyleButton,
                            width: '100%',
                            top: '10px',
                            background: '#EE8865'
                          }}
                          onClick={onView}
                        >
                          <UnorderedListOutlined />
                          Load more...
                        </Button>
                      </Col>
                      <Col span={22}>
                        <Button
                          disabled={loadMap}
                          loading={loadMap}
                          style={{
                            ...btnStyle,
                            ...textStyleButton,
                            width: '100%',
                            top: '10px'
                          }}
                          onClick={() => setOpen(false)}
                        >
                          <CloseOutlined />
                          Close
                        </Button>
                      </Col>
                    </Row>
                  }
                  width={'100%'}
                >
                  <Row justify="space-around" align="stretch">
                    <Col span={22}>
                      <Filters
                        {...{
                          prefix,
                          filters,
                          setFilters,
                          refetch,
                          role: 'USER',
                          optional: false,
                          setUnlocked: (...args) => {
                            setOpen(false);
                            setUnlocked(...args);
                          },
                          unlocked
                        }}
                      />
                    </Col>
                  </Row>
                  <Row
                    justify="space-around"
                    align="stretch"
                    style={{ flex: 1, overflowY: 'auto' }}
                  >
                    <Col span={22}>
                      {loading ? (
                        <Row justify="center" style={{ height: '100%' }}>
                          <Col>
                            <Spin size="large" indicator={antIcon} />
                          </Col>
                        </Row>
                      ) : (
                        <Plans items={items} viewMode={0} getActions={getActions} />
                      )}
                    </Col>
                  </Row>
                </Modal>
              </Col>
            </div>
          </Row>
        </div>
      </MobileView>
      {!unlocked && (
        <div className={_s.overlay}>
          <div className={_s.overlayСontent}>
            <Row justify="center">
              <Col span={22}>
                <p>
                  <Link to="/login">Log in</Link> or <Link to="/register">register now</Link> to
                  view over 500 results
                </p>
              </Col>
              <Col span={22}>
                <RegisterForm action={() => gaEvent('register_from_map_view', 'register:done')} />
              </Col>
            </Row>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

ListContainer.propTypes = {
  user: PropTypes.object.isRequired,
  prefix: PropTypes.string.isRequired,
  queries: PropTypes.object.isRequired
};

const connectedList = connect(mapStateToProps, mapDispatchToProps)(ListContainer);

export default connectedList;
